import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import { delay, motion } from 'framer-motion';
import logoVideo from '../../assets/video/logoVideo.webm';

export const Advt = ({ currentState }) => {
  const {
    title,
    qrTitle1,
    qrCode1,
    qrTitle2,
    qrCode2,
    titleFontSize,
    sizeQR,
    paddingQR,
  } = useGetParams();

  let isCenter = currentState === 'S1';

  return (
    <div className={styles.advtBlock}>
      <motion.div
        initial={{
          left: isCenter ? '-110rem' : 0,
          top: isCenter ? '10rem' : 0,
          scale: isCenter ? 1.15 : 1,
        }}
        animate={{
          left: isCenter ? '-110rem' : 0,
          top: isCenter ? '10rem' : 0,
          scale: isCenter ? 1.15 : 1,
        }}
        transition={{ duration: 0.5 }}
        className={styles.logoBlock}
      >
        <video autoPlay="autoplay" muted="muted" playsInline>
          <source src={logoVideo} type="video/webm"></source>
        </video>
      </motion.div>

      {title && (
        <motion.div
          initial={{
            left: isCenter ? '-42rem' : 0,
            top: isCenter ? '-10rem' : 0,
            scale: 0,
          }}
          animate={{
            left: isCenter ? '-42rem' : 0,
            top: isCenter ? '-10rem' : 0,
            scale: isCenter ? 1.9 : 1,
          }}
          transition={{ duration: 0.5 }}
          className={styles.title}
          style={{
            fontSize: `${titleFontSize}rem`,
            lineHeight: `${titleFontSize}rem`,
          }}
        >
          {title
            .trim()
            .split(' ')
            .map((word, idx) => (
              <motion.div
                initial={{
                  scale: 0,
                }}
                animate={{
                  scale: 1,
                }}
                transition={{ scale: { delay: idx * 0.5, duration: 0.5 } }}
                key={word + idx}
              >
                {word}
              </motion.div>
            ))}
        </motion.div>
      )}

      {qrCode1 && (
        <motion.div
          initial={{
            left: isCenter ? '-88rem' : 0,
            top: isCenter ? '15rem' : 0,
            scale: 0,
            opacity: 0,
          }}
          animate={{
            left: isCenter ? '-88rem' : 0,
            top: isCenter ? '15rem' : 0,
            scale: isCenter ? 1.3 : 1,
            opacity: 1,
          }}
          transition={{ opacity: { duration: 0.6, delay: 0.5 }, duration: 1 }}
          className={styles.qrCode}
          style={{
            padding: `${paddingQR}rem`,
          }}
        >
          {qrTitle1 && <div className={styles.qrTitle}>{qrTitle1}</div>}
          <img
            src={qrCode1}
            alt="QR"
            style={{
              minHeight: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              width: `${sizeQR}rem`,
            }}
          />
        </motion.div>
      )}

      {qrCode2 && (
        <motion.div
          initial={{
            left: isCenter ? '-40rem' : 0,
            top: isCenter ? '-17.8rem' : 0,
            scale: 0,
            opacity: 0,
          }}
          animate={{
            left: isCenter ? '-40rem' : 0,
            top: isCenter ? '-17.8rem' : 0,
            scale: isCenter ? 1.3 : 1,
            opacity: 1,
          }}
          transition={{ opacity: { duration: 0.6, delay: 0.5 }, duration: 1 }}
          className={styles.qrCode}
          style={{
            padding: `${paddingQR}rem`,
          }}
        >
          {qrTitle2 && <div className={styles.qrTitle}>{qrTitle2}</div>}
          <img
            src={qrCode2}
            alt="QR"
            style={{
              minHeight: `${sizeQR}rem`,
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          />
        </motion.div>
      )}
    </div>
  );
};
